import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

const SidebarHeader = ({ height = 108, title }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box sx={{
      position: 'sticky',
      top: 0,
      height: `${height}px`,
      borderBottom: `2px solid ${theme.palette.divider}`,
      bgcolor: 'grey.800',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      pointerEvents: 'auto',
      zIndex: 350,
    }}>
      <Typography variant="subtitle2" sx={{ fontSize: "16px", color: 'white', fontWeight: 600 }}>
        {title ?? t('common:gantt.categories_header')}
      </Typography>
    </Box>
  );
};

export default SidebarHeader;
